import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { PM2JourneyIntroOverviewPageLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(PM2JourneyIntroOverviewPageLayout, {
  condensed: true,
  hideTitle: true,
});

export const PM2JourneyIntroOverviewPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
      resource={resource}
    />
  );
};
